export default "__VITE_ASSET__8017d0ae__"